import * as React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Formik, FormikProps } from 'formik';
import { VoucherApi } from 'common/api/resources/Voucher';
import { Member } from 'common/api/models/Member';
import { FormInput } from '../form/FormInput';

export interface ApplicationStatusDropDownDialog {}
interface ApplicationStatusDropDownDialogProps {
  title?: string;
  isOpen: boolean;
  voucher: string;
  member?: Member;
  onSave: () => void;
  onCancel: () => void;
  applicationStatus?: string;
  submittedDate?: string;
  approvedDate?: string;
  error?: string;
}
export interface ApplicationStatusDropDownDialogState {
  error?: string;
}
class FormValues {
  applicationStatus: string;
}

export class ApplicationStatusDropDownDialog extends React.Component<
  ApplicationStatusDropDownDialogProps,
  ApplicationStatusDropDownDialogState
> {
  state: ApplicationStatusDropDownDialogState = {
    error: '',
  };

  initialValues() {
    return {
      applicationStatus: this.props.applicationStatus,
    };
  }

  handleSubmit = async (values: FormValues) => {
    if (this.props.voucher) {
      let updateParams = {};
      updateParams = {
        applicationStatus: values.applicationStatus,
      };
      let nowDate = new Date();
      let nowDateIso = nowDate.toISOString();
      if (values.applicationStatus === 'SUBMITTED') {
        updateParams = {
          applicationStatus: values.applicationStatus,
          submittedDate: nowDateIso,
        };
      }

      if (values.applicationStatus === 'APPROVED') {
        // console.log('voucher', this.props.applicationStatus);
        updateParams = {
          applicationStatus: values.applicationStatus,
          approvedDate: nowDateIso,
          ...(this.props.applicationStatus === 'PENDING' && { submittedDate: nowDateIso }), // DEV-1520: User skipped using SUBMIT status, so we'll use it as same date time.
        };
      }

      // console.log(updateParams);
      VoucherApi.updateVoucher(this.props.voucher, updateParams)
        .then(() => {
          this.props.onSave();
        })
        .catch(e => {
          this.setState({ error: e.response.data.message });
        });
    }
  };

  render() {
    return (
      <Modal size="md" isOpen={this.props.isOpen} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<FormValues>) => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>{this.props.title ? this.props.title : ''}</ModalHeader>
              <ModalBody>
                <FormInput
                  id="applicationStatus"
                  name="applicationStatus"
                  label="Application Status"
                  tag="select"
                  autoComplete="off"
                >
                  <option value="PENDING">PENDING</option>
                  <option value="SUBMITTED">SUBMITTED</option>
                  <option value="APPROVED">APPROVED</option>
                </FormInput>
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit">
                    Save
                  </Button>
                </div>
              </ModalFooter>

              {this.state!.error && <div className="alert alert-danger">{this.state!.error}</div>}
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/ApplicationStatusDropDownDialog.tsx